export const now =
    typeof performance !== 'undefined' && performance && typeof performance.now === 'function' ? () => performance.now() : Date.now;
